<template>
  <div class="voice-reply">
    <!-- 主面板 -->

    <div class="main-panel">


      <!-- 顶部标签页 -->
      <div class="tabs-header">
        <div class="panel-header">
          <h2 class="panel-title"><i class="fas fa-file-alt"></i> 直播话术管理</h2>
        </div>

        <div class="tabs-container">
          <button
              v-for="tab in tabs"
              :key="tab.id"
              :class="['tab-btn', { active: activeTab === tab.id }]"
              @click="activeTab = tab.id"
          >
            <i :class="tab.icon"></i>
            <span>{{ tab.name }}</span>
          </button>
        </div>
        <button class="add-btn" @click="showAddModal = true">
          <i class="fas fa-plus"></i>
          <span>添加一组</span>
        </button>
      </div>

      <!-- 话术列表 -->
      <div class="content-area">
        <!-- 其他话术组 -->
        <div v-if="currentGroupTalks.length > 0" class="talks-grid">
          <div v-for="talk in currentGroupTalks" :key="talk.id" class="talk-card" :class="{ expanded: talk.expanded }"
               @click="toggleExpand(talk)">
            <div class="talk-name">{{ talk.name }}</div>
            <div class="talk-time">{{ talk.create_time }}</div>
            <div class="talk-actions">
              <button class="action-btn edit-btn" @click.stop="editTalk(talk)">
                <i class="fas fa-edit"></i>
              </button>
              <button class="action-btn delete-btn" @click.stop="deleteTalk(talk)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="fas fa-file-text"></i>
          <p>暂无话术</p>
          <button class="btn btn-primary" @click="showAddModal = true">添加话术</button>
        </div>
      </div>
    </div>

    <!-- 添加/编辑话术弹窗 -->
    <div v-if="showAddModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-wrapper">
          <div class="modal-header">
            <h3 class="modal-title">{{ editingTalk ? '编辑话术' : '添加话术' }}</h3>
            <button class="modal-close" @click="closeModal">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>话术名称</label>
              <input type="text" v-model="talkForm.name" class="form-input" placeholder="请输入话术名称">
            </div>

          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeModal">取消</button>
            <button class="btn btn-primary" @click="saveTalk">确认</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新写改写话术弹窗 -->
    <div v-if="showImageModal" class="modal-overlay" @click.self="closeImageModal">
      <div class="modal-container-wide">
        <div class="modal-wrapper">
          <div class="modal-header">
            <h3 class="modal-title">AI话术助手</h3>
            <button class="modal-close" @click="closeImageModal">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="ai-content">
              <!-- 左侧：话术改写 -->
              <div class="ai-panel rewrite-panel">
                <div class="panel-header">
                  <div class="panel-icon">
                    <i class="fas fa-edit"></i>
                  </div>
                  <h4 class="panel-title">话术改写</h4>
                </div>
                <div class="panel-body">
                  <div class="upload-box">
                    <div class="upload-icon-wrapper">
                      <i class="fas fa-plus"></i>
                    </div>
                    <p class="upload-tip">建议视频10分钟左右 文字3000字左右 也可上传几小时视频或者几万字文本</p>
                    <p class="upload-format">支持MP4, WAV, TXT格式文件</p>
                  </div>
                  <div class="form-group">
                    <label class="form-label">改写要求(选填)</label>
                    <textarea class="form-textarea" placeholder="请输入改写要求..."></textarea>
                  </div>
                  <div class="form-group">
                    <label class="form-label">过滤违禁词(选填)</label>
                    <textarea class="form-textarea" placeholder="请输入需要过滤的违禁词..."></textarea>
                  </div>
                  <button class="btn btn-rewrite">快速改写</button>
                </div>
              </div>

              <!-- 右侧：话术新写 -->
              <div class="ai-panel write-panel">
                <div class="panel-header">
                  <div class="panel-icon write-icon">
                    <i class="fas fa-file-alt"></i>
                  </div>
                  <h4 class="panel-title">话术新写</h4>
                </div>
                <div class="panel-body">
                  <div class="form-group">
                    <label class="form-label">
                      <i class="fas fa-lightbulb"></i> 建议列出详细产品信息和话术要求
                    </label>
                    <textarea class="form-textarea-large" placeholder="请详细描述产品信息和话术要求..."></textarea>
                  </div>
                  <button class="btn btn-write">快速新写</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeImageModal">取消</button>
          </div>
        </div>
      </div>
    </div>

    <float-menu></float-menu>
  </div>
</template>

<script>

import FloatMenu from "@/components/floatMenu.vue";
export default {
  components: {FloatMenu},
  data() {
    return {
      texts: "",
      keyConfig: {},
      activeTab: 'anchor',
      showImageModal: false,
      tabs: [
        {id: 'anchor', name: '主播话术组', icon: 'fas fa-microphone'},
        {id: 'keyword', name: '关键词话术组', icon: 'fas fa-key'},
        {id: 'timing', name: '插播报时话术组', icon: 'fas fa-clock'},
        {id: 'welcome', name: '进间欢迎话术组', icon: 'fas fa-heart'}
      ],
      talks: {},
      showAddModal: false,
      editingTalk: null,
      talkForm: {
        name: '',
        content: ''
      },

    }
  },
  computed: {

    referenceText() {
      return this.$store.state.referenceText;
    },
    currentGroupTalks() {
      return this.talks[this.activeTab] || []
    },
    aiPlayStatus() {
      return this.$store.state.aiPlayStatus;
    },
    apiKey() {
      return this.$store.state.apiKey;
    }
  },

  async mounted() {
    this.getList();
    document.addEventListener('click', this.handleClickOutside)

  },

  methods: {
    async getList() {

      const list = await this.Db("话术管理").order("id", "desc").select();
      var arr = {
        anchor: [],
        cohost: [],
        keyword: [],
        timing: [],
        welcome: []
      }
      if (list) {
        list.forEach(v => {
          arr[v.type].push(v);
        })
        this.talks = arr
      }

    },

    toggleExpand(talk) {
      talk.expanded = !talk.expanded
    },
    editTalk(talk) {
      const talkData = encodeURIComponent(JSON.stringify(talk))
      this.$router.push({
        path: '/image-function',
        query: {type: this.activeTab, talkId: talk.id}
      })
    },
    async deleteTalk(talk) {

      const confirm = await this.$dialog.confirm({
        title: "温馨提示",
        message: `确定要删除"${talk.name}"吗？`,
        okText: "删除",
        cancelText: "取消",

      }).catch(() => false);

      if (confirm !== false) {
        console.log(talk.id)

        const res = await this.Db("话术管理").where("id", talk.id).delete();

        if (res) {
          this.$dialog.tips({
            message: "删除成功",
            type: "success"
          })
          this.getList()
          return;
        }
        this.$dialog.tips({
          message: "删除失败",
          type: "error"
        })

        return;
      }


    },
    getNowTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    async saveTalk() {
      if (!this.talkForm.name.trim()) {
        this.$dialog.tips({
          message: "请输入话术名称",
          type: "error"
        })
        return
      }

      if (this.editingTalk) {
        // 编辑模式


        const index = this.talks[this.activeTab].findIndex(t => t.id === this.editingTalk.id)
        if (index !== -1) {
          this.talks[this.activeTab][index] = {
            ...this.talks[this.activeTab][index],
            name: this.talkForm.name,
            content: this.talkForm.content,
            time: new Date().toLocaleString('zh-CN')
          }
        }
        alert('修改成功')
      } else {
        // 添加模式

        const res = await this.Db("话术管理").add({
          "name": this.talkForm.name.trim(),
          "type": this.activeTab,
          "create_time": this.getNowTime()
        });

        if (res) {
          this.getList();
          this.$dialog.tips({
            message: "添加成功",
            type: "success"
          })
          this.closeModal();
          return;
        }

        this.$dialog.tips({
          message: "添加失败",
          type: "error"
        })

      }

    },
    closeModal() {
      this.showAddModal = false
      this.editingTalk = null
      this.talkForm = {
        name: '',
        content: ''
      }
    },
    closeImageModal() {
      this.showImageModal = false
    }
  }
}
</script>

<style scoped>
.voice-reply {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.main-panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 35px;
  position: relative;
  overflow: hidden;
  min-height: 500px;
}

.side-more-services {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 10;
}

.side-more-btn {
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
  height: 100px;
  border: none;
  border-radius: 0 16px 16px 0;
  background: linear-gradient(180deg, rgba(139, 92, 246, 0.4) 0%, rgba(99, 102, 241, 0.4) 100%);
  border: 1px solid rgba(167, 139, 250, 0.4);
  color: #c4b5fd;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  padding-left: 8px;
  transition: all 0.3s ease;
}

.side-more-btn:hover {
  background: linear-gradient(180deg, rgba(139, 92, 246, 0.5) 0%, rgba(99, 102, 241, 0.5) 100%);
  color: #e9d5ff;
}

.side-more-btn span {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: translateX(-3px);
}

.side-more-btn .arrow {
  font-size: 14px;
  font-weight: bold;
}

.side-more-btn:hover {
  background: linear-gradient(180deg, rgba(139, 92, 246, 0.5) 0%, rgba(99, 102, 241, 0.5) 100%);
  box-shadow: 6px 0 22px rgba(139, 92, 246, 0.35),
  inset 0 1px 0 rgba(167, 139, 250, 0.3);
  transform: translateY(-50%) scale(1.05);
}

.side-more-panel {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 180px;
  background: rgba(35, 35, 35, 0.98);
  border-radius: 12px 0 0 12px;
  padding: 16px 0;
  transition: all 0.3s ease;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.side-panel-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 12px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
  border-bottom: 1px solid rgba(170, 170, 170, 0.2);
}

.side-panel-close {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(80, 80, 80, 0.5);
  border: 1px solid rgba(170, 170, 170, 0.2);
  border-radius: 6px;
  color: rgba(170, 170, 170, 0.7);
  cursor: pointer;
  transition: all 0.3s ease;
}

.side-panel-close:hover {
  background: rgba(100, 100, 100, 0.6);
  color: rgba(200, 200, 200, 0.9);
}

.side-panel-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 16px 12px;
  border: none;
  background: transparent;
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  cursor: pointer;
  position: relative;
  z-index: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  border-radius: 8px;
}

.side-panel-item:hover {
  background: rgba(170, 170, 170, 0.1);
  color: #f0f0f0;
}

.item-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(167, 139, 250, 0.3) 100%);
  border-radius: 12px;
  border: 1px solid rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.side-panel-item:hover .item-icon-wrapper {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.5) 0%, rgba(167, 139, 250, 0.5) 100%);
  border-color: rgba(102, 126, 234, 0.5);
  transform: scale(1.05);
}

.item-icon-wrapper i {
  font-size: 22px;
  color: rgba(180, 180, 180, 0.9);
}

.side-panel-item:hover .item-icon-wrapper i {
  color: #ffffff;
}

.item-text {
  font-size: 13px;
  font-weight: 500;
}

.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
  margin-bottom: 20px;
  gap: 15px;
}

.tabs-header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.tabs-container {
  display: flex;
  gap: 6px;
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.9) 0%, rgba(25, 25, 25, 0.9) 100%);
  padding: 5px;
  border-radius: 16px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 2px 8px rgba(170, 170, 170, 0.1),
  inset 0 1px 0 rgba(170, 170, 170, 0.1);
}

.tabs-container .tab-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 22px;
  border: none;
  border-radius: 12px;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  color: rgba(170, 170, 170, 0.9);
}

.tab-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: rgba(170, 170, 170, 0.6);
  transition: all 0.3s ease;
}

.tabs-container .tab-btn:hover {
  color: #f0f0f0;
  background: rgba(170, 170, 170, 0.15);
  transform: translateY(-1px);
}

.tab-btn:hover::before {
  left: 10%;
  width: 80%;
}

.tabs-container .tab-btn.active {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.5) 0%, rgba(99, 102, 241, 0.5) 100%);
  color: #c4b5fd !important;
  box-shadow: 0 4px 16px rgba(139, 92, 246, 0.3),
  0 1px 0 rgba(167, 139, 250, 0.3);
  transform: translateY(-1px);
  border: 1px solid rgba(167, 139, 250, 0.5);
}

.tab-btn.active::before {
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.3);
}

.tab-btn i {
  font-size: 14px;
}

.tab-btn.active i {
  color: #e9d5ff;
}

.tab-btn span {
  position: relative;
  z-index: 1;
}

.new-rewrite-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  border: 1px solid rgba(80, 80, 80, 0.4);
  border-radius: 8px;
  background: rgba(70, 70, 70, 0.2);
  color: #aaa;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.new-rewrite-btn:hover {
  background: rgba(90, 90, 90, 0.3);
  border-color: rgba(100, 100, 100, 0.5);
}

.add-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 20px;
  border: 1px solid rgba(102, 126, 234, 0.4);
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.4) 0%, rgba(167, 139, 250, 0.4) 100%);
  color: #c4b5fd;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.add-btn:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.5) 0%, rgba(167, 139, 250, 0.5) 100%);
  border-color: rgba(102, 126, 234, 0.6);
  color: #ddd6fe;
  transform: translateY(-1px);
}

.content-area {
  min-height: 400px;
}

.talks-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.talk-card {
  background: rgba(35, 35, 35, 0.95);
  border: 1px solid rgba(170, 170, 170, 0.2);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
  position: relative;
}

.talk-card:hover {
  transform: translateY(-2px);
  border-color: rgba(170, 170, 170, 0.4);
}

.talk-name {
  font-size: 16px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
  margin-bottom: 8px;
}

.talk-time {
  font-size: 12px;
  color: #999;
}

.talk-content {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(170, 170, 170, 0.2);
  font-size: 13px;
  color: rgba(150, 150, 150, 0.8);
  line-height: 1.6;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.talk-expand {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(150, 150, 150, 0.6);
  transition: all 0.3s ease;
}

.talk-expand:hover {
  color: rgba(170, 170, 170, 0.9);
}

.talk-expand.expanded {
  transform: rotate(180deg);
}

.talk-card.expanded {
  padding-bottom: 48px;
}

.talk-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.talk-card:hover .talk-actions {
  opacity: 1;
}

.new-rewrite-card {
  background: rgba(35, 35, 35, 0.95);
  border-color: rgba(170, 170, 170, 0.3);
  cursor: pointer;
}

.new-rewrite-card:hover {
  transform: translateY(-2px);
  border-color: rgba(170, 170, 170, 0.5);
}

.new-rewrite-card .talk-name i {
  font-size: 16px;
  margin-right: 8px;
  color: rgba(170, 170, 170, 0.7);
}

.action-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(170, 170, 170, 0.1);
  color: rgba(170, 170, 170, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.action-btn:hover {
  background: rgba(170, 170, 170, 0.2);
  color: #f0f0f0;
}

.edit-btn {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.4) 0%, rgba(37, 99, 235, 0.4) 100%);
  color: #93c5fd;
  border: 1px solid rgba(147, 197, 253, 0.4);
}

.edit-btn:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.5) 0%, rgba(37, 99, 235, 0.5) 100%);
  color: #bfdbfe;
  border-color: rgba(147, 197, 253, 0.6);
}

.delete-btn {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.4) 0%, rgba(220, 38, 38, 0.4) 100%);
  color: #fca5a5;
  border: 1px solid rgba(248, 113, 113, 0.4);
}

.delete-btn:hover {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.5) 0%, rgba(220, 38, 38, 0.5) 100%);
  color: #fecaca;
  border-color: rgba(248, 113, 113, 0.6);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
  color: rgba(170, 170, 170, 0.5);
}

.empty-state p {
  font-size: 16px;
  margin-bottom: 20px;
}

/* API对接弹窗样式 */
.api-modal {
  width: 100%;
  max-width: calc(100vw - 20px);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}

.api-header {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 12px 12px 0 0;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.api-header .modal-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.api-body {
  padding: 30px;
  background: #1e1e24;
}

.engine-selector {
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-bottom: 30px;
}

.engine-card {
  width: 160px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(60, 60, 65, 0.8) 0%, rgba(45, 45, 50, 0.8) 100%);
  border: 2px solid transparent;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  text-align: center;
}

.engine-card:hover {
  transform: translateY(-4px);
}

.engine-card.active {
  border-color: rgba(139, 92, 246, 0.6);
  box-shadow: 0 0 20px rgba(139, 92, 246, 0.3);
}

.engine-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 24px;
  color: #fff;
}

.volcano-icon {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%);
}

.tongyi-icon {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 50%, #1d4ed8 100%);
}

.engine-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
}

.engine-card.active .engine-badge {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
}

.engine-card:not(.active) .engine-badge {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.engine-name {
  display: block;
  color: #e5e7eb;
  font-size: 14px;
  font-weight: 500;
}

.api-input-section {
  margin-bottom: 16px;
}

.api-label {
  display: block;
  color: #9ca3af;
  font-size: 13px;
  margin-bottom: 8px;
}

.input-with-tip {
  position: relative;
}

.api-input {
  width: 100%;
  padding: 12px 14px;
  background: rgba(55, 55, 60, 0.8);
  border: 1px solid rgba(80, 80, 90, 0.6);
  border-radius: 10px;
  color: #e5e7eb;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.api-input:focus {
  border-color: rgba(139, 92, 246, 0.6);
  box-shadow: 0 0 0 0.2rem rgba(139, 92, 246, 0.15);
}

.api-input::placeholder {
  color: #6b7280;
}

.input-tip {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  font-size: 12px;
}

.api-tip-section {
  text-align: center;
}

.api-tip {
  color: #6b7280;
  font-size: 12px;
}

.api-footer {
  padding: 16px 24px;
  background: #18181c;
  border-radius: 0 0 12px 12px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-outline {
  padding: 10px 20px;
  border: 1px solid rgba(70, 70, 80, 0.8);
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(55, 55, 60, 0.95) 0%, rgba(45, 45, 50, 0.95) 100%);
  color: #d1d5db;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: linear-gradient(135deg, rgba(70, 70, 75, 0.95) 0%, rgba(55, 55, 60, 0.95) 100%);
  color: #fff;
  border-color: rgba(100, 100, 110, 0.8);
}

.btn-test {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.9) 0%, rgba(234, 88, 12, 0.9) 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-test:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
}

.api-submit {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.9) 0%, rgba(22, 163, 74, 0.9) 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.api-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.4);
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.modal-container {
  width: 90%;
  max-width: 500px;
  animation: modalIn 0.3s ease;
}

.modal-wrapper {
  background: rgba(35, 35, 35, 0.98);
  border: 1px solid rgba(170, 170, 170, 0.2);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: rgba(170, 170, 170, 0.2);
}

.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.modal-close {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  cursor: pointer;
  padding: 6px 10px;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.modal-body {
  padding: 24px;
}

.ai-robot-modal .modal-body {
  max-height: 70vh;
  overflow-y: auto;

}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 10px;
  background: rgba(35, 35, 35, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(170, 170, 170, 0.15);
}

.form-input::placeholder {
  color: #777;
}

.form-textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 10px;
  background: #2a2a2a;
  color: #ccc;
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-textarea:focus {
  outline: none;
  border-color: #888;
  box-shadow: 0 0 0 0.2rem rgba(100, 100, 100, 0.2);
}

.form-textarea::placeholder {
  color: #777;
}

/* AI话术助手弹窗样式 */
.modal-container-wide {
  width: 95%;
  max-width: 1200px;
  animation: modalIn 0.3s ease;
}

.ai-content {
  display: flex;
  gap: 24px;
}

.ai-panel {
  flex: 1;
  background: rgba(40, 40, 45, 0.95);
  border-radius: 16px;
  border: 1px solid rgba(80, 80, 85, 0.6);
  overflow: hidden;
}

.ai-panel .panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%);
  border-bottom: 1px solid rgba(139, 92, 246, 0.2);
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(99, 102, 241, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a78bfa;
  font-size: 16px;
}

.panel-icon.write-icon {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(14, 165, 233, 0.3) 100%);
  color: #60a5fa;
}

.panel-title {
  font-size: 16px;
  font-weight: 600;
  color: #f0f0f0;
  margin: 0;
}

.ai-panel .panel-body {
  padding: 24px;
}

.upload-box {
  border: 2px dashed rgba(139, 92, 246, 0.4);
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  background: rgba(30, 30, 35, 0.8);
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 14px;
}

.upload-box:hover {
  border-color: rgba(139, 92, 246, 0.8);
  background: rgba(40, 40, 45, 0.9);
}

.upload-icon-wrapper {
  width: 40px;
  height: 40px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.25) 0%, rgba(99, 102, 241, 0.25) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #a78bfa;
  transition: transform 0.3s ease;
}

.upload-box:hover .upload-icon-wrapper {
  transform: scale(1.1);
}

.upload-tip {
  color: #ccc;
  font-size: 13px;
  margin: 8px 0;
  line-height: 1.6;
}

.upload-format {
  color: #777;
  font-size: 12px;
  margin: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  color: #aaa;
  font-size: 13px;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-textarea-large {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 10px;
  background: rgba(30, 30, 35, 0.8);
  color: #ccc;
  font-size: 14px;
  min-height: 355px;
  resize: vertical;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-textarea-large:focus {
  outline: none;
  border-color: rgba(139, 92, 246, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(139, 92, 246, 0.1);
}

.form-textarea-large::placeholder {
  color: #777;
}

.btn-rewrite {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-rewrite:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 1) 0%, rgba(99, 102, 241, 1) 100%);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);
  transform: translateY(-1px);
}

.btn-write {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.8) 0%, rgba(14, 165, 233, 0.8) 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-write:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 1) 0%, rgba(14, 165, 233, 1) 100%);
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.4);
  transform: translateY(-1px);
}

.image-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.image-section {
  width: 100%;
}

.upload-area {
  border: 2px dashed rgba(139, 92, 246, 0.5);
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  background: rgba(35, 35, 35, 0.8);
  transition: all 0.3s ease;
  cursor: pointer;
}

.upload-area:hover {
  border-color: rgba(139, 92, 246, 0.8);
  background: rgba(45, 45, 45, 0.9);
}

.upload-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(99, 102, 241, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #a78bfa;
}

.upload-area p {
  color: #ccc;
  margin: 8px 0;
  font-size: 14px;
}

.upload-hint {
  color: #777 !important;
  font-size: 12px !important;
}

.textarea-section {
  width: 100%;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background: #252525;
}

/* 按钮样式 */
.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: rgba(170, 170, 170, 0.2);
  color: rgba(170, 170, 170, 0.9);
  border: 1px solid rgba(170, 170, 170, 0.3);
}

.add-btn:hover {
  transform: translateY(-2px);
  background: rgba(170, 170, 170, 0.3);
  color: #f0f0f0;
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-secondary:hover {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.7) 0%, rgba(75, 85, 99, 0.7) 100%);
  border-color: rgba(156, 163, 175, 0.7);
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .voice-reply {
    padding: 12px;
  }

  .tabs-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .tabs-container {
    flex-wrap: wrap;
    justify-content: center;
  }

  .tab-btn {
    padding: 10px 16px;
    font-size: 13px;
  }

  .add-btn {
    justify-content: center;
  }

  .content-area {
    padding: 16px;
  }

  .talks-grid {
    grid-template-columns: 1fr;
  }
}

/* AI替你播弹窗样式 */
.ai-robot-modal {
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 20px;
}

.ai-robot-header {
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.2) 0%, rgba(239, 68, 68, 0.2) 100%);
  border-bottom: 1px solid rgba(251, 146, 60, 0.3);
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.8) 0%, rgba(239, 68, 68, 0.8) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  margin-right: 12px;
}

.ai-robot-content {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.robot-panel {
  flex: 1;
  background: rgba(40, 40, 45, 0.95);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(80, 80, 85, 0.5);
}

.robot-panel.left-panel {
  border-color: rgba(251, 146, 60, 0.3);
}

.robot-panel.right-panel {
  border-color: rgba(59, 130, 246, 0.3);
}

.robot-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  gap: 10px;
}

.header-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;
  margin-right: 0;
}

.text-file-input {
  display: none;
}

.text-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.text-btn-import {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.text-btn-import:hover {
  background: rgba(16, 185, 129, 0.2);
}

.text-btn-export {
  background: rgba(251, 146, 60, 0.2);
  color: #fb923c;
  border: 1px solid rgba(251, 146, 60, 0.4);
}

.text-btn-export:hover {
  background: rgba(251, 146, 60, 0.3);
}

.panel-icon.orange-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.3) 0%, rgba(239, 68, 68, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fb923c;
}

.panel-icon.blue-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(14, 165, 233, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #3b82f6;
}

.word-count {
  margin-left: auto;
  background: rgba(251, 146, 60, 0.2);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  color: #fb923c;
}

.audio-upload-section {
  margin-top: 16px;
  border-top: 1px solid #e5e7eb;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.audio-upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(139, 92, 246, 0.1);
  border: 1px dashed #8b5cf6;
  border-radius: 8px;
  color: #8b5cf6;
  cursor: pointer;
  transition: all 0.2s ease;
}

.audio-upload-btn:hover {
  background: rgba(139, 92, 246, 0.2);
  border-color: #7c3aed;
}

.audio-file-input {
  display: none;
}


.audio-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  color: #374151;
  font-size: 14px;
}

.audio-info i {
  color: #8b5cf6;
}

.audio-play-btn,
.audio-delete-btn,
.audio-download-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.audio-play-btn {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

.audio-play-btn:hover {
  background: rgba(139, 92, 246, 0.2);
}

.audio-delete-btn {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.audio-delete-btn:hover {
  background: rgba(239, 68, 68, 0.2);
}

.audio-download-btn {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.audio-download-btn:hover {
  background: rgba(16, 185, 129, 0.2);
}

.download-section {
  margin: 12px 0;
  display: none;
}

.example-dropdown {
  margin-left: auto;
  position: relative;
}

.example-dropdown select {
  appearance: none;
  background: linear-gradient(135deg, rgba(60, 60, 65, 0.9) 0%, rgba(45, 45, 50, 0.9) 100%);
  border: 1px solid rgba(80, 80, 90, 0.6);
  border-radius: 10px;
  padding: 8px 32px 8px 14px;
  color: #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  min-width: 120px;
  transition: all 0.3s ease;
}

.example-dropdown::after {
  content: '\f078';
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
  font-size: 12px;
}

.example-dropdown select:hover {
  background: linear-gradient(135deg, rgba(70, 70, 75, 0.95) 0%, rgba(55, 55, 60, 0.95) 100%);
  border-color: rgba(100, 100, 110, 0.8);
  color: #f3f4f6;
}

.example-dropdown select:focus {
  border-color: rgba(251, 146, 60, 0.6);
  box-shadow: 0 0 0 0.2rem rgba(251, 146, 60, 0.15), 0 0 15px rgba(251, 146, 60, 0.1);
}

.example-dropdown select option {
  background: #2a2a30;
  color: #e5e7eb;
  padding: 8px 12px;
}

.example-dropdown select option:hover {
  background: rgba(251, 146, 60, 0.3);
}

.example-dropdown select option:checked {
  background: rgba(251, 146, 60, 0.4);
  color: #fb923c;
}

.textarea-container {
  position: relative;
}

.robot-textarea {
  width: 100%;
  height: 265px;
  padding: 14px;
  padding-bottom: 36px;
  border: none;
  border-radius: 8px;
  background: rgba(30, 30, 35, 0.9);
  color: #ccc;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
}

.word-count-floating {
  position: absolute;
  bottom: 10px;
  right: 14px;
  font-size: 12px;
  color: #fb923c;
  background: rgba(251, 146, 60, 0.2);
  padding: 4px 10px;
  border-radius: 12px;
}

.robot-textarea:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(251, 146, 60, 0.2);
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #666;
  margin-top: 8px;
}

.product-info-panel {
  padding: 16px;
}

.product-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.product-row.full-width {
  flex-direction: column;
}

.product-item {
  flex: 1;
}

.product-item.full {
  width: 100%;
}

.product-item label {
  display: block;
  font-size: 12px;
  color: #888;
  margin-bottom: 6px;
}

.product-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(80, 80, 85, 0.5);
  border-radius: 8px;
  background: rgba(30, 30, 35, 0.8);
  color: #ccc;
  font-size: 13px;
  box-sizing: border-box;
}

.product-input:focus {
  outline: none;
  border-color: rgba(59, 130, 246, 0.5);
}

.product-textarea {
  width: 100%;
  min-height: 300px;
  padding: 10px 12px;
  border: 1px solid rgba(80, 80, 85, 0.5);
  border-radius: 8px;
  background: rgba(30, 30, 35, 0.8);
  color: #ccc;
  font-size: 13px;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
}

.product-textarea:focus {
  outline: none;
  border-color: rgba(59, 130, 246, 0.5);
}

.service-options {
  margin-top: 12px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #aaa;
}

.checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #3b82f6;
}

.checkbox-label input[type="number"] {
  width: 60px;
  padding: 4px 8px;
  border: 1px solid rgba(80, 80, 85, 0.5);
  border-radius: 6px;
  background: rgba(30, 30, 35, 0.8);
  color: #ccc;
  font-size: 12px;
  text-align: center;
}

.mini-input {
  width: 50px !important;
}

.practice-section,
.config-section {
  background: rgba(40, 40, 45, 0.8);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 16px;
  border: 1px solid rgba(80, 80, 85, 0.4);
  flex: 1;
}

.sections-row {
  display: flex;
  gap: 16px;
}

.section-header {
  margin-bottom: 12px;
}

.section-header h4 {
  margin: 0;
  font-size: 14px;
  color: #ddd;
  font-weight: 500;
}

.practice-options,
.config-options {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.btn-start {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.8) 0%, rgba(239, 68, 68, 0.8) 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}


.btn-start:hover {
  background: linear-gradient(135deg, rgba(251, 146, 60, 1) 0%, rgba(239, 68, 68, 1) 100%);
  box-shadow: 0 4px 15px rgba(251, 146, 60, 0.4);
  transform: translateY(-1px);
}

.btn-start-active {
  background: linear-gradient(135deg, rgba(36, 169, 251, 0.8) 0%, rgba(2, 113, 255, 0.8) 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 14px;

}

.btn-start-active:hover {
  background: linear-gradient(135deg, rgba(36, 169, 251, 1) 0%, rgba(2, 113, 255, 1) 100%);
  box-shadow: 0 4px 15px rgba(251, 146, 60, 0.4);
  transform: translateY(-1px);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(60, 60, 60, 0.1);
}


.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 15px 30px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
}


.panel:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
}


/* AI替你播响应式 */
@media (max-width: 900px) {
  .ai-robot-content {
    flex-direction: column;
  }

  .practice-options,
  .config-options {
    flex-direction: column;
  }
}
</style>